import mod from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./phone.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./phone.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./ClientApp/shared/phone.vue?vue&type=script&lang=js&
// module id = 18
// module chunks = 2 5